if (!customElements.get("product-modal")) {
  customElements.define(
    "product-modal",
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.selectedMediaIndex = 0;
        this.header = document.querySelector(".section-header");
        this.mobileMenuToogle = document.querySelector(".mobile-menu-toggle");
        this.modalMedias = this.querySelectorAll(".product-media-wrap");
        this.modalMediaThumbnails = this.querySelectorAll(".product-media-modal-thumbnails .product-media-modal-thumbnail");

        this.boxZoomElement = this.querySelector(".box-zoom-element");
        this.boxZoomElementInner = this.querySelector(".box-zoom-element .box-zoom-inner");
        this.zoomRatio = 1.5;

        this.infoScreen = this.querySelector(".modal-pinch-zoom-info-screen");
      }

      connectedCallback() {
        Array.from(this.modalMediaThumbnails).forEach((thumbnail) => {
          thumbnail.addEventListener("click", (e) => {
            this.handleThumbnailClick(e);
          }
        )})

        if(window.innerWidth >= 990) {
          this.modalMedias.forEach((media) => {
            media.addEventListener("mouseover", (e) => {
              this.revealBoxElement(media, e);
            });
          });

          this.modalMedias.forEach((media) => {
            media.addEventListener("mousemove", (e) => {
              this.mouseZoom(e);
            });
          });

          this.modalMedias.forEach((media) => {
            media.addEventListener("mouseout", (e) => {
              this.hideBoxElement(media, e);
            });
          });
        }
      }


      mouseZoom(e) {
        requestAnimationFrame(() => {
          const image = e.target;
          const ratio = image.height / image.width;
          const container = image.getBoundingClientRect();
          const xPosition = e.clientX - container.left;
          const yPosition = e.clientY - container.top;
          const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
          const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

          this.boxZoomElementInner.style.backgroundPosition = `${xPercent} ${yPercent}`;
          this.boxZoomElementInner.style.backgroundSize = `${image.width * this.zoomRatio}px`;
        });
      }

      hide() {
        super.hide();
        this.header.style.zIndex = "1001";
        this.mobileMenuToogle.style.zIndex = "99999999";
      }

      show(opener) {
        this.header.style.zIndex = "1";
        this.mobileMenuToogle.style.zIndex = "1";
        super.show(opener);
        this.showActiveMedia();
        if(window.innerWidth <= 989) {
          this.hideInfoScreen();
        }
      }

      hideInfoScreen() {
        this.infoScreen.classList.add("info-screen-hidden");
      }

      handleThumbnailClick(e) {
        this.modalMediaThumbnails.forEach((thumbnail) => {
          thumbnail.classList.remove("active");
        });

        const thumbnailElement = e.target.closest(".product-media-modal-thumbnail");
        const thumbnailIndex = thumbnailElement.dataset.thumbnailIndex;

        thumbnailElement.classList.add("active");

        this.modalMedias.forEach((media) => {
          if (media.dataset.modalImageIndex === thumbnailIndex) {
            media.classList.add("active");
            if(!media.parentElement.classList.contains("pinch-zoom-container") && !media.querySelector("deferred-media")) {
              new PinchZoom.default(media, {});
            }
          } else {
            media.classList.remove("active");
          }
        });

      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove("active");
        });
        let activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

        // select first media if unable to find active media
        if (!activeMedia) {
          activeMedia = this.querySelector("[data-media-id]");
        }

        const activeMediaTemplate = activeMedia.querySelector("template");
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        activeMedia.classList.add("active");

        let activeModalMedia = null;
        this.modalMedias.forEach((mediaWrapper) => {
          const imageMediaId =  mediaWrapper.querySelector("img").getAttribute("data-media-id");

          if (imageMediaId === activeMedia.getAttribute("data-media-id")) {
            mediaWrapper.classList.add("active");
            activeModalMedia = mediaWrapper;
            if(!mediaWrapper.parentElement.classList.contains("pinch-zoom-container") && !mediaWrapper.querySelector("deferred-media")) {
              new PinchZoom.default(mediaWrapper, {});
            }
          } else {
            mediaWrapper.classList.remove("active");
          }
        });

        this.modalMediaThumbnails.forEach((thumbnail) => {
          if (thumbnail.dataset.thumbnailIndex === activeModalMedia.getAttribute("data-modal-image-index")) {
            thumbnail.classList.add("active");
          } else {
            thumbnail.classList.remove("active");
          }
        });

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == "DEFERRED-MEDIA" && activeMediaContent && activeMediaContent.querySelector(".js-youtube")) activeMedia.loadContent();
      }

      // whe image is hovered, reveal the box element and move it with the mouse
      revealBoxElement(media, event) {
        const image = media.querySelector("img");
        const video = media.querySelector("deferred-media");
        if(!image || video) return;
        this.boxZoomElement.classList.remove("hidden");
        // set inner element background image
        const imageSrc = image.getAttribute("src");
        this.boxZoomElementInner.style.backgroundImage = `url(${imageSrc})`;

      }

      // when image is not hovered, hide the box element
      hideBoxElement(image, event) {
        this.boxZoomElement.classList.add("hidden");
      }

    }
  );
}